import React, {
  FC, useEffect, useState,
} from 'react';
import { Box, Cab, ParcelUser } from '../../../../../lib/types';
import { updateFoodifoxData } from '../../../../../lib/axios/FoodifoxDataAPI';
import SuccessContent from './SuccessContent';
import OpenBoxSuccess from '../../../FetchCode/OpenBoxSuccess';

const RegisterSuccess: FC<Props> = ({
  onClose,
  isEnglish,
  setIsEnglish,
  cab,
  orderIdList,
  cabOrderBoxMap,
  setShowLoading,
  userId,
  registerUserInfo,
}) => {
  const [openBoxes, { loading }] = updateFoodifoxData<{ box: Box, orderId: number }[]>('/foxH5Take/openBoxByTempUser');
  const [boxes, setBoxes] = useState<{ box: Box, orderId: number }[]>([]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setShowLoading(loading);

    return () => {
      setShowLoading(false);
    };
  }, [loading]);

  return (
    <>
      {
        boxes.length === 0 ? (
          <SuccessContent
            onClose={onClose}
            isEnglish={isEnglish}
            setIsEnglish={setIsEnglish}
            cab={cab}
            userId={userId}
            orderIdList={orderIdList}
            cabOrderBoxMap={cabOrderBoxMap}
            setShowLoading={setShowLoading}
            openBoxes={(orderIdList, userId) => {
              openBoxes({
                param: {
                  userId,
                  orderIdList,
                },
                onCompleted: (data) => {
                  setBoxes(data);
                },
              });
            }}
            registerUserInfo={registerUserInfo}
          />
        ) : (
          <OpenBoxSuccess
            isEnglish={isEnglish}
            setIsEnglish={setIsEnglish}
            setShowLoading={setShowLoading}
            orderIds={orderIdList}
            boxNumbers={boxes.map((box) => box.box.boxNumber)}
            phoneNumber={registerUserInfo?.phoneNumber}
          />
        )
      }
    </>
  );
};

export interface Props {
  onClose: () => void;
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
  cab: Cab;
  orderIdList: number[];
  cabOrderBoxMap?: { [key: number]: { boxCount: number; orderBoxList: string[] } };
  setShowLoading: (isShow: boolean) => void;
  userId?: number;
  registerUserInfo?: ParcelUser;
}

export default RegisterSuccess;
